module.exports = __webpack_public_path__ + "img/3.f2ad6aa2.jpg";